/**
 * NIÑOZ — ninoz-koopbalk.js
 *
 * Doel: op de productpagina mag niets voor de koopknop staan.
 *
 * De Klaviyo-strook 'Claim jouw korting' staat fixed onderaan elk scherm
 * (50px hoog, z-index 90000) en bedekte op mobiel de onderste 50 van de
 * 84 pixels van de meeschuivende koopbalk — precies waar de knop zit.
 *
 * Dit script zet de klasse ninoz-pdp op <body> zodra de pagina een
 * product-sticky-bar bevat (dat is alleen zo op een productpagina).
 * ninoz-animations.css verbergt de strook dan op die pagina's.
 * Op alle andere pagina's blijft de strook gewoon staan, dus je blijft
 * e-mailadressen verzamelen.
 *
 * Laden: defer src="{{ 'ninoz-koopbalk.js' | asset_url }}"
 */

(function () {
  'use strict';

  function markeer() {
    if (!document.body) return;
    if (document.querySelector('product-sticky-bar, .product-sticky-bar')) {
      document.body.classList.add('ninoz-pdp');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markeer);
  } else {
    markeer();
  }

  /* Het thema wisselt secties uit zonder herladen; opnieuw controleren. */
  document.addEventListener('shopify:section:load', markeer);
})();
